import { useAuthenticatedQuery } from '../../client/hooks';
import { useAppState } from '../../client/providers/AppProvider';
import {
    Espin_Game_Definition_Enum,
    PlayerTeamSelectComponentDocument,
    PlayerTeamSelectComponentQuery,
    PlayerTeamSelectComponentQueryVariables,
    TeamSelectComponentDocument,
    TeamSelectComponentQuery,
    TeamSelectComponentQueryVariables,
} from '../../generated/spin-graphql';

export const useGetTeamsCount = ({ game }: { game: Espin_Game_Definition_Enum }) => {
    const { user } = useAppState();
    const { data: playerTeams } = useAuthenticatedQuery<
        PlayerTeamSelectComponentQuery,
        PlayerTeamSelectComponentQueryVariables
    >({
        query: PlayerTeamSelectComponentDocument,
        pause: !!!user || !!!game,
        variables: { userId: user?.id, game },
    });

    const { data: hsTeams } = useAuthenticatedQuery<TeamSelectComponentQuery, TeamSelectComponentQueryVariables>({
        query: TeamSelectComponentDocument,
        pause: !!!user || !!!game,
        variables: { highSchoolId: user?.high_school_profile?.high_school?.id, game },
    });

    return { teamsCount: Math.max(playerTeams?.espin_team?.length ?? 0, hsTeams?.espin_team?.length ?? 0) };
};
